export const WARNINGS_CONFIRMATION_MODAL_NAME =
  'WARNINGS_CONFIRMATION_MODAL_NAME';
